<template>
  <ul class="report-list">
    <li v-for="item in posts" :key="item">
      <div>
        {{ item.title }}
        <ul>
          <li v-if="item.file1"><a target="_blank" :href="item.file1.url">{{ item.file1.title }}</a></li>
          <li v-if="item.file2" ><a target="_blank" :href="item.file2.url">{{ item.file2.title }}</a></li>
        </ul>
      </div>
    </li>
  </ul>
</template>
<script>
import axios from "axios";

export default {
  name: "ReportList",
  data() {
    return {
      posts: []
    }
  },
  created() {
    this.getReports();
  },
  methods: {
    getReports() {
      const sendData = {
        action: "get_about_reports",
        _security: AJAX_TARGET.nonce,
      };
      const params = new URLSearchParams(sendData);
      axios
          .post(AJAX_TARGET.api, params)
          .then(( { data }) => {
            this.posts = data
          })
          .catch((error) => {
            console.log(error);
          });
      }
  }
}
</script>
<style lang="scss" scoped>
.report-list {
  @apply md:flex flex-wrap mx-auto;

  li {
    @apply md:w-1/2 text-lg;

    a {
      text-decoration: underline;
      color: #666666;
      @apply text-15;

      &:hover {
        text-decoration: none;
      }
    }

    div {
      @apply border-white border-b-2 py-9;
    }

    ul li {
      width: 100%;
      @apply border-0 mx-0 mt-2 py-0 px-0;
    }
  }
}
</style>

